/** funksjon som ikke gjør noen ting. Erstatter _.noop fra lodash */
export const tomFunksjon = () => {
};
